import { render } from "./FormGenerator.vue?vue&type=template&id=3480be70"
import script from "./FormGenerator.vue?vue&type=script&lang=js"
export * from "./FormGenerator.vue?vue&type=script&lang=js"

import "./FormGenerator.vue?vue&type=style&index=0&id=3480be70&setup=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__